import { createElement } from 'react';
import { hydrateRoot } from 'react-dom/client';
import { App } from '../App';
import type { ResponseModel } from '../priceStatistic';
import './styles.css';

type DeviceType = 'mobile' | 'tablet' | 'desktop';

type AppProps = {
    adId: number;
    deviceType: DeviceType;
    response: ResponseModel;
    showLink: boolean;
};

const ROOT_ID = 'price-statistics-podlet-root';
const CONFIG_ID = 'price-statistics-podlet-config';

const shadowRoot = document.querySelector('price-statistics-podlet')?.shadowRoot;

const root = shadowRoot?.getElementById(ROOT_ID) ?? document.getElementById(ROOT_ID);
const configElement = shadowRoot?.getElementById(CONFIG_ID) ?? document.getElementById(CONFIG_ID);

if (root && configElement?.textContent && !root.dataset.hydrated) {
    root.dataset.hydrated = 'true';
    const props = JSON.parse(configElement.textContent) as AppProps;
    hydrateRoot(root, createElement(App, props));
}
